import { jsx as _jsx } from "react/jsx-runtime";
import { DeliveryScheduleRemappingText } from "../utils/DSRM-typesAndEnums";
import Typography from "@mui/material/Typography";
export const DSRM_Title = ({ remappingModalTitle = DeliveryScheduleRemappingText.DEFAULT_TITLE_COPY, }) => (_jsx(Typography, Object.assign({ variant: "h2", color: "primary" }, { children: remappingModalTitle })));
